module.exports = __webpack_public_path__ + "media/images/pasma-logo-74c846cc34d660ab1c29f9d2e47fc655.jpg";